// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "unity_build.proto" (package "unity_build", syntax proto3)
// tslint:disable
import { UnityBuildService } from "./unity_build";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service unity_build.UnityBuildService
 */
export class UnityBuildServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = UnityBuildService.typeName;
        this.methods = UnityBuildService.methods;
        this.options = UnityBuildService.options;
    }
    /**
     * @generated from protobuf rpc: GetContracts
     */
    getContracts(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetContractByCustomId
     */
    getContractByCustomId(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
